import * as Yup from 'yup';
import { FormRegExp } from '../../constants/FormRegExp';

export default () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required('Field is required')
      .matches(FormRegExp.STRING_WITH_SPECIAL_CHARS, 'Type correct characters')
      .max(50, 'First name is too long - should be 50 chars maximum'),
    lastName: Yup.string()
      .required('Field is required')
      .matches(FormRegExp.STRING_WITH_SPECIAL_CHARS, 'Type correct characters')
      .max(50, 'Last name is too long - should be 50 chars maximum'),
    email: Yup.string().required('Field is required').email('Email has the wrong format'),
    password: Yup.string()
      .required('Field is required')
      .min(6, 'Password is too short - should be 6 chars minimum.'),
    passwordRepeat: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must be the same')
      .required('Field is required')
      .min(6, 'Password is too short - should be 6 chars minimum.'),
    status: Yup.object().shape({
      value: Yup.string().required('Field is required'),
    }),
    role: Yup.string().required('Field is required'),
  });
